import { useLocation, useParams } from "react-router-dom";
import { IoLinkSharp, IoLogoLinkedin } from "react-icons/io5";
import { FaFacebookSquare } from "react-icons/fa";
import { MdOutlineEmail } from "react-icons/md";
import { Button, Modal, Spinner } from "react-bootstrap";
import { useEffect, useState } from "react";
import { TiTimes } from "react-icons/ti";
import axios from "axios";
import qs from "qs";
import successCheck from "../../components/assets/animation-check.gif";

const JobDetails = () => {
  const location = useLocation();
  const { id } = useParams();
  const [jobs, setJobs] = useState([]);
  const [jobData, setJobData] = useState(null);
  const [jobFormModal, setJobFormModal] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [copied, setCopied] = useState(false);

  const shareUrl = `${window.location.origin}/careers/job/${jobData?.jobId}`;
  const title = "Check this out!";
  const summary = "Here's something interesting I found.";
  const emailBody = `${summary}\n\nRead more at: ${shareUrl}`;

  const handleSendMail = () => {
    const subject = encodeURIComponent("Job Application");
    const body = encodeURIComponent(
      "Hello,\n\nI am interested in the job opening.\n\nRegards,\nJohn Doe"
    );
    const mailtoLink = `mailto:hr@example.com?subject=${subject}&body=${body}`;
    window.location.href = mailtoLink;
  };

  useEffect(() => {
    const sheetId = "14S-tBzPkc0p3g8fbJmoYJsPnQZ3L5i9DpV-1S69F_6A";
    const sheetName = "Sheet1"; // Change if your sheet name is different
    const url = `https://docs.google.com/spreadsheets/d/${sheetId}/gviz/tq?tqx=out:json&sheet=${sheetName}`;

    fetch(url)
      .then((res) => res.text())
      .then((text) => {
        const json = JSON.parse(text.substring(47).slice(0, -2)); // Trim the Google API response
        console.log("Raw JSON Data:", json);
        const formatted = formatGoogleSheetData(
          json?.table?.cols,
          json?.table?.rows
        );
        console.log("Formatted Data:", formatted);
        setJobs(formatted);
      });
  }, []);

  function formatGoogleSheetData(cols, rows) {
    // Step 1: Extract valid column labels
    const headers = cols.map((col) => col.label.trim());

    // Step 2: Filter out empty labels and track their indexes
    const validIndexes = headers
      .map((label, index) => (label ? { label, index } : null))
      .filter(Boolean);

    // Step 3: Map rows to objects using valid labels
    return rows.map((row) => {
      const obj = {};
      validIndexes.forEach(({ label, index }) => {
        const cell = row.c[index];
        const value = cell?.v ?? "";

        // Optional: Normalize multi-line or numbered strings into arrays
        if (
          [
            "tags",
            "responsibilities",
            "qualifications",
            "niceToHave",
            "benefitAndPerks",
            "recruitmentProcess",
            "howToApply",
            "notForYou",
          ].includes(label)
        ) {
          obj[label] = value
            .split("\n")
            .map((line) => line.replace(/^\d+\.\s*/, "").trim())
            .filter(Boolean);
        } else if (label === "postedDate" && cell.f) {
          // Use formatted date if available
          obj[label] = cell.f;
        } else {
          obj[label] = typeof value === "string" ? value.trim() : value;
        }
      });
      return obj;
    });
  }

  useEffect(() => {
    if (id && jobs.length > 0) {
      const job = jobs.find((job) => job.jobId === id);
      if (job) {
        setJobData(job);
      } else {
        console.error("Job not found for ID:", id);
      }
    }
  }, [jobs, id]);

  const handleCopy = async (textToCopy) => {
    try {
      await navigator.clipboard.writeText(textToCopy);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Reset copied state after 2 seconds
      alert("Link copied to clipboard!");
    } catch (err) {
      console.error("Failed to copy!", err);
    }
  };

  return (
    <div className="container">
      <JobFormModal
        open={jobFormModal}
        close={() => setJobFormModal(false)}
        jobData={jobData}
        openSuccessModal={() => setSuccessModal(true)}
      />
      <SuccessModal
        open={successModal}
        close={() => setSuccessModal(false)}
        jobData={jobData}
      />
      <div className="row pt-3" style={{ borderBottom: "2px solid #216fb8" }}>
        <div className="col-md-7">
          <h2 style={{ fontWeight: "bold" }}>{jobData?.jobTitle}</h2>
          <p className="py-2">
            {jobData?.experience} |{" "}
            {jobData?.tags?.map((item) => {
              return `${item} / `;
            })}
          </p>
        </div>
        <div className="topApplyButton col-md-5 col-sm-12 d-flex justify-content-end align-items-center">
          <button
            className="btn btn-primary searchIconBtn w-50"
            onClick={() => setJobFormModal(true)}
          >
            Apply Now
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12 pt-2">
          <div className="row">
            <div className="col-md-6 pt-2">
              <div className="mb-2">
                <h5 className="fw-bold">About the Role</h5>
                <p>{jobData?.aboutRole}</p>
              </div>
              <div className="mb-2">
                <h5 className="fw-bold">Key Responsibilities</h5>
                <ul>
                  {jobData?.responsibilities?.map((item, i) => {
                    return <li key={i}>{item}</li>;
                  })}
                </ul>
              </div>
              <div className="mb-2">
                <h5 className="fw-bold">Required Qualifications</h5>
                <ul>
                  {jobData?.qualifications?.map((item, i) => {
                    return <li key={id}>{item}</li>;
                  })}
                </ul>
              </div>
              <div className="mb-2">
                <h5 className="fw-bold">Nice to Have</h5>

                <ul>
                  {jobData?.niceToHave?.map((item, i) => {
                    return <li key={i}>{item}</li>;
                  })}
                </ul>
              </div>
              <div className="mb-2">
                <h5 className="fw-bold">Benefits & Perks</h5>
                <ul>
                  {jobData?.benefitAndPerks?.map((item, i) => {
                    return <li key={i}>{item}</li>;
                  })}
                </ul>
              </div>
              <div className="mb-2">
                <h5 className="fw-bold">This Role Is Not for You If:</h5>
                <ul>
                  {jobData?.notForYou?.map((item, i) => {
                    return <li key={1}>{item}</li>;
                  })}
                </ul>
              </div>
              <div className="mb-2">
                <h5 className="fw-bold">About Us</h5>
                <p>{jobData?.aboutUs}</p>
              </div>
              <div className="mb-2">
                <h5 className="fw-bold">How To Apply</h5>
                <ol>
                  {jobData?.howToApply?.map((item, i) => {
                    return <li key={i}>{item}</li>;
                  })}
                </ol>
              </div>
              <div className="mb-2">
                <h5 className="fw-bold">Recruitment Process</h5>
                <ol>
                  {jobData?.recruitmentProcess?.map((item, i) => {
                    return <li key={1}>{item}</li>;
                  })}
                </ol>
              </div>
              <div className="mb-2">
                <h5 className="fw-bold">Data Privacy Notice:</h5>
                <p>{jobData?.privacyNotice}</p>
              </div>
            </div>
            <div className="detailsBox col-md-6 col-sm-12 p-2">
              <div className="jobInfoBox py-5 px-3 rounded">
                <div
                  className="px-3 pb-4"
                  style={{ borderBottom: "1px solid #216fb8" }}
                >
                  <div className="jobInfoTitle fw-bold py-2">Job Info</div>
                  <div className="jobInfoDetails">
                    <div className="mb-1">
                      <span className="text-muted">Job ID</span>:{" "}
                      {jobData?.jobId}
                    </div>
                    <div className="mb-1">
                      <span className="text-muted">Posted Date</span>:
                      {jobData?.postedDate}
                    </div>
                    <div className="mb-1">
                      <span className="text-muted">Location</span>:{" "}
                      {jobData?.location}
                    </div>
                    <div className="mb-1">
                      <span className="text-muted">Location Type</span>:{" "}
                      {jobData?.locationType}
                    </div>
                    <div className="mb-1">
                      <span className="text-muted">Employment Type</span>:
                      {jobData?.employmentType}
                    </div>
                  </div>
                </div>

                <div className="px-3 pb-4 mt-3">
                  <div className="jobInfoTitle fw-bold py-2">Share</div>
                  <div className="jobInfoDetails">
                    <div className="mb-2 cursorPointer">
                      <button
                        onClick={() => {
                          handleCopy(
                            `${window.location.origin}/careers/${jobData?.jobId}`
                          );
                        }}
                        className="btn me-3"
                      >
                        <IoLinkSharp className="me-3" size={18} />
                        Copy Link
                      </button>
                    </div>
                    <div className="mb-2 cursorPointer">
                      <button
                        onClick={() => {
                          window.open(
                            `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                              `${window.location.origin}/careers/${jobData?.jobId}`
                            )}`,
                            "_blank"
                          );
                        }}
                        className="btn me-3"
                      >
                        <FaFacebookSquare className="me-3" size={18} />
                        Facebook
                      </button>
                    </div>
                    <div className="mb-2 cursorPointer">
                      <button
                        onClick={() => {
                          window.open(
                            `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
                              `${window.location.origin}/careers/${jobData?.jobId}`
                            )}`,
                            "_blank"
                          );
                        }}
                        className="btn me-3"
                      >
                        <IoLogoLinkedin className="me-3" size={18} />
                        LinkedIn
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-12 py-5 d-flex justify-content-center align-items-center">
          <button
            className="btn btn-primary searchIconBtn applyButton"
            onClick={() => setJobFormModal(true)}
          >
            Apply Now
          </button>
        </div>
      </div>
    </div>
  );
};

const JobFormModal = ({ open, close, jobData, openSuccessModal }) => {
  const [resumeFile, setResumeFile] = useState(null);
  const [videoFile, setVideoFile] = useState(null);
  const [resumeUrl, setResumeUrl] = useState("");
  const [videoUrl, setVideoUrl] = useState("");
  const [formData, setFormData] = useState({
    jobId: jobData ? jobData.jobId : "",
    jobTitle: jobData ? jobData.jobTitle : "",
    name: "",
    mobile: "",
    email: "",
    resumeLink: "",
    videoLink: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [resumeError, setResumeError] = useState("");
  const [videoError, setVideoError] = useState("");
  const [videoUploadUrl, setVideoUploadUrl] = useState("");

  const toBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file); // Reads file and converts to Base64 string with MIME type prefix
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const getResumeUrl = async () => {
    if (!resumeFile) throw new Error("No file provided");
    // Generate a random filename with original file extension
    const fileExtension = resumeFile.name.split(".").pop();
    const randomFileName = `resume_${Date.now()}_${Math.random()
      .toString(36)
      .substring(2, 10)}.${fileExtension}`;
    const base64String = await toBase64(resumeFile);
    const pureBase64 = base64String.split(",")[1];
    const formData = {
      filename: randomFileName,
      filedata: pureBase64,
    };
    try {
      const response = await axios.post(
        "https://w78ji8c8fc.execute-api.ap-south-1.amazonaws.com/default/instape-dev-public-s3-lambda",
        formData
      );
      console.log("response", response);
      // Adjust the return key depending on your backend response
      return response.data.url;
    } catch (error) {
      console.error("File upload failed:", error);
      throw error;
    }
  };

  const getVideoUploadUrl = async () => {
    if (!videoFile) throw new Error("No file provided");
    // Generate a random filename with original file extension
    const fileExtension = videoFile.name.split(".").pop();
    const randomFileName = `video_${Date.now()}_${Math.random()
      .toString(36)
      .substring(2, 10)}.${fileExtension}`;
    try {
      const response = await axios.post(
        "https://2t6e2sync5.execute-api.ap-south-1.amazonaws.com/default/instape-dev-s3-video-upload",
        {
          filename: randomFileName,
        }
      );
      console.log("Response from file upload URL:", response.data);
      console.log("Video file:", videoFile);
      try {
        let response2 = await fetch(response.data.upload_url, {
          method: "PUT",
          body: videoFile,
          headers: {
            "Content-Type": videoFile.type,
          },
        });
        if (response2.ok) {
          return `https://instape-public.s3.ap-south-1.amazonaws.com/uploads/${randomFileName}`;
        }
      } catch (uploadError) {
        console.error("Video upload failed:", uploadError);
        throw uploadError;
      }
      setVideoUploadUrl(response.data.upload_url);
    } catch (error) {
      console.error("File upload failed:", error);
      throw error;
    }
  };

  const getVideoUrl = async () => {
    if (!videoFile) throw new Error("No file provided");
    // Generate a random filename with original file extension
    const fileExtension = videoFile.name.split(".").pop();
    const randomFileName = `resume_${Date.now()}_${Math.random()
      .toString(36)
      .substring(2, 10)}.${fileExtension}`;
    const base64String = await toBase64(videoFile);
    const pureBase64 = base64String.split(",")[1];
    const formData = {
      filename: randomFileName,
      filedata: pureBase64,
    };

    try {
      const response = await axios.post(
        "https://w78ji8c8fc.execute-api.ap-south-1.amazonaws.com/default/instape-dev-public-s3-lambda",
        formData
      );
      // Adjust the return key depending on your backend response
      return response.data.url;
    } catch (error) {
      console.error("File upload failed:", error);
      throw error;
    }
  };

  useEffect(() => {
    if (jobData) {
      setFormData((prevData) => ({
        ...prevData,
        jobId: jobData.jobId,
        jobTitle: jobData.jobTitle,
      }));
    }
  }, [jobData]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const resumeFileSizeInMB = resumeFile.size / (1024 * 1024); // Convert bytes to MB
    if (resumeFileSizeInMB > 10) {
      setResumeError(`File must be smaller than 10 MB`);
      setIsLoading(false);
      return;
    }

    const videoFileSizeInMB = videoFile.size / (1024 * 1024); // Convert bytes to MB
    if (videoFileSizeInMB > 10) {
      setVideoError(`File must be smaller than 10 MB`);
      setIsLoading(false);
      return;
    }

    let resumeUrl = await getResumeUrl();
    let videoUrl = await getVideoUploadUrl();

    // Validate file size

    const params = new URLSearchParams();
    params.append("jobId", formData.jobId);
    params.append("jobTitle", formData.jobTitle);
    params.append("name", formData.name);
    params.append("mobile", formData.mobile);
    params.append("email", formData.email);
    params.append("resumeUrl", resumeUrl);
    params.append("videoUrl", videoUrl);

    try {
      await axios.post(
        "https://script.google.com/macros/s/AKfycbxRCbYOH7CjaWwy-FMv5PsKKf0_m8016PsfEN50bbFixas3cx6iL8YGxNW-M3TRbRd9/exec",
        params,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          // This will prevent axios from throwing on CORS error
          validateStatus: function () {
            return true;
          },
        }
      );
    } catch (err) {
      // This block will still not catch a CORS error – browser blocks it
      console.warn("Likely CORS issue: request may have succeeded", err);
    }

    // Reset form
    setFormData({
      jobId: "",
      jobTitle: "",
      name: "",
      mobile: "",
      email: "",
      resumeLink: "",
      videoLink: "",
    });
    openSuccessModal();
    close();
    setIsLoading(false);
  };

  return (
    <Modal show={open} onHide={close} size="lg" className="jobFormModal">
      <Modal.Body>
        <div className="d-flex justify-content-between p-2">
          <h5 className="formHeading">Please Fill Out the Form to Apply</h5>
          <TiTimes
            onClick={close}
            className="cursorPointer"
            size={30}
            color="#216fb8"
          />
        </div>
        <form onSubmit={handleSubmit} className="px-2 py-3">
          <div className="row">
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="mb-1">
                  Applying For<span className="text-primary">*</span>
                </label>
                <input
                  className="form-control"
                  onChange={handleChange}
                  value={formData.jobTitle}
                  required
                />
              </div>
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="mb-1">
                  Name <span className="text-primary">*</span>
                </label>
                <input
                  placeholder="Enter your name"
                  className="form-control"
                  onChange={handleChange}
                  value={formData.name}
                  name="name"
                  required
                />
              </div>
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="mb-1">
                  Phone Number<span className="text-primary">*</span>
                </label>
                <input
                  className="form-control"
                  onChange={handleChange}
                  value={formData.mobile}
                  name="mobile"
                  type="tel"
                  pattern="[0-9]{10}"
                  placeholder="Enter your phone number"
                  title="Please enter a valid 10-digit phone number"
                  required
                />
              </div>
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="mb-1">
                  Email<span className="text-primary">*</span>
                </label>
                <input
                  placeholder="Enter your email address"
                  className="form-control"
                  type="email"
                  onChange={handleChange}
                  value={formData.email}
                  name="email"
                  required
                />
              </div>
            </div>
            <div className="col-md-12 mb-3">
              <div className="form-group">
                <label className="mb-2">
                  Please upload your resume
                  <span className="text-primary">*</span>
                  <div className="textSmall">
                    Upload 1 supported file. Max 10 MB (doc, docx & pdf)
                  </div>
                </label>
                <input
                  className="form-control"
                  type="file"
                  accept=".pdf, .doc, .docx"
                  onChange={(event) => setResumeFile(event.target.files[0])}
                  required
                />
                {resumeError && (
                  <div style={{ fontSize: 12 }} className="text-danger mt-2">
                    {resumeError}
                  </div>
                )}
              </div>
            </div>
            <div className="col-md-12 mb-3">
              <div className="form-group">
                <label className="mb-2">
                  Please upload a brief, 1-minute professional video introducing
                  yourself
                  <span className="text-primary">*</span>
                  <div className="textSmall">
                    Upload 1 supported file: video. Max 10 MB. (mp4)
                  </div>
                </label>
                <input
                  className="form-control"
                  type="file"
                  accept="video/mp4"
                  onChange={(event) => {
                    setVideoFile(event.target.files[0]);
                    setVideoError(""); // Reset error when a new file is selected
                  }}
                  required
                />
                {videoError && (
                  <div style={{ fontSize: 12 }} className="text-danger mt-2">
                    {videoError}
                  </div>
                )}
              </div>
            </div>
            <div className="col-md-12 mb-3 d-flex justify-content-center">
              {isLoading ? (
                <button
                  type="button"
                  className="btn btn-primary searchIconBtn w-25"
                >
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />{" "}
                  Loading...
                </button>
              ) : (
                <button
                  type="submit"
                  className="btn btn-primary searchIconBtn w-25"
                >
                  Submit
                </button>
              )}
            </div>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

const SuccessModal = ({ open, close }) => {
  return (
    <Modal show={open} onHide={close} size="sm" centered keyboard={false}>
      <Modal.Body className="text-center">
        <div>
          <img
            src={successCheck}
            alt="Success"
            style={{ width: "100px", height: "100px" }}
          />
        </div>
        <p className="mb-2 fw-bold">Application Submitted Successfully!</p>
        <p className="text-muted" style={{ fontSize: "14px" }}>
          We’ll review your application. If your profile is a good fit, our team
          will reach out shortly.
        </p>
      </Modal.Body>
    </Modal>
  );
};

export default JobDetails;
